import { DndContext, closestCenter, MouseSensor, TouchSensor, KeyboardSensor, useSensor, useSensors, DragOverlay } from "@dnd-kit/core";
import { SortableContext, useSortable, rectSortingStrategy, arrayMove, sortableKeyboardCoordinates } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { useState } from "react";
import { api } from "@/lib/api";
import { cErr } from "./CloudLayout";

function Item({ id, disabled, children }) {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id, disabled });
  const style = { transform: CSS.Transform.toString(transform), transition, opacity: isDragging ? 0.3 : 1, touchAction: disabled ? "auto" : "manipulation",
    WebkitTouchCallout: "none", WebkitUserSelect: "none", userSelect: "none" };
  // long-press must start a drag, not the phone's image menu
  return <div ref={setNodeRef} style={style} {...attributes} {...listeners} onContextMenu={(e) => !disabled && e.preventDefault()} data-testid={`cloud-sortable-${id}`}>{children}</div>;
}

export function saveOrder(ctx, ids) {
  return api.put("/cloud/order", { ctx, ids }).catch(cErr);
}

export default function SortableGrid({ items, setItems, ctx, disabled, className, render }) {
  const [active, setActive] = useState(null);
  const sensors = useSensors(
    useSensor(MouseSensor, { activationConstraint: { distance: 8 } }),
    useSensor(TouchSensor, { activationConstraint: { delay: 250, tolerance: 14 } }),
    useSensor(KeyboardSensor, { coordinateGetter: sortableKeyboardCoordinates }),
  );
  const end = ({ active: a, over }) => {
    setActive(null);
    document.body.style.overflow = "";
    if (!over || a.id === over.id) return;
    const next = arrayMove(items, items.findIndex((x) => x.id === a.id), items.findIndex((x) => x.id === over.id));
    setItems(next);
    saveOrder(ctx, next.map((x) => x.id));
  };
  const cur = active && items.find((x) => x.id === active);
  return (
    <DndContext sensors={sensors} collisionDetection={closestCenter} onDragStart={(e) => { setActive(e.active.id); navigator.vibrate?.(20); document.body.style.overflow = "hidden"; }} onDragEnd={end} onDragCancel={() => { setActive(null); document.body.style.overflow = ""; }}>
      <SortableContext items={items.map((x) => x.id)} strategy={rectSortingStrategy} disabled={disabled}>
        <div className={className}>
          {items.map((x, i) => <Item key={x.id} id={x.id} disabled={disabled}>{render(x, i)}</Item>)}
        </div>
      </SortableContext>
      <DragOverlay>{cur ? <div className="scale-105 shadow-2xl rounded-lg ring-2 ring-[var(--cl-accent)] overflow-hidden">{render(cur, -1)}</div> : null}</DragOverlay>
    </DndContext>
  );
}
